exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tax-filing-feature-icon{height:60px;width:60px;border-radius:100%}.tax-filing-feature-icon-title{width:85px}.tax-filing-feature-icon-subtitle{width:100%}", ""]);

// exports
